import { useRef, useState, useEffect } from "react";
import { useDataBufferContext } from "../../context/useDataBuffer.js";
const validateParams = (row, column) => {
  return row !== void 0 && column !== void 0 && row !== -1;
};
const useCellData = ({ row, column, columns }) => {
  const isMounted = useRef(false);
  const { buffer } = useDataBufferContext();
  const columnConfig = columns[column];
  const columnIndex = (columnConfig == null ? void 0 : columnConfig.index) ?? column;
  const getCell = (c) => {
    return c ?? buffer.getCell(row, columnIndex) ?? { value: columnConfig == null ? void 0 : columnConfig.defaultValue };
  };
  const getRow = (r) => {
    return r ?? buffer.getRow(row);
  };
  const [data, setData] = useState({
    row: getRow(),
    cell: getCell()
  });
  const handleUpdate = async (value) => {
    await buffer.updateCell({
      row,
      column: columnIndex,
      value,
      ghost: !data.row
    });
  };
  const handleCellChange = (c, r) => {
    if (isMounted.current) {
      setData({ row: getRow(r), cell: getCell(c) });
    }
  };
  useEffect(() => {
    isMounted.current = true;
    return () => {
      isMounted.current = false;
    };
  }, []);
  useEffect(() => {
    if (validateParams(row, columnIndex)) {
      buffer.addCellChangeListener(row, columnIndex, handleCellChange);
      handleCellChange();
    }
    return () => {
      if (validateParams(row, columnIndex)) {
        buffer.removeCellChangeListener(row, columnIndex);
      }
    };
  }, [row, columnIndex]);
  return {
    ...data,
    buffer,
    columnConfig,
    onUpdateCell: handleUpdate
  };
};
export {
  useCellData
};
